import { __decorate, __param } from 'tslib';
import { InjectionToken, Injectable, PLATFORM_ID, NgModule, Inject, Pipe } from '@angular/core';
import { isPlatformBrowser, CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
const WINDOW = new InjectionToken('WINDOW_TOKEN');
class WindowRef {
    get nativeWindow() {
        throw new Error('Not implemented');
    }
}
let BrowserWindowRef = class BrowserWindowRef extends WindowRef {
    constructor() {
        super();
    }
    get nativeWindow() {
        return window;
    }
};
BrowserWindowRef.ɵfac = function BrowserWindowRef_Factory(t) { return new (t || BrowserWindowRef)(); };
BrowserWindowRef.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BrowserWindowRef, factory: function (t) { return BrowserWindowRef.ɵfac(t); } });
function windowFactory(browserWindowRef, platformId) {
    if (isPlatformBrowser(platformId)) {
        return browserWindowRef.nativeWindow;
    }
    return new Object();
}
const WINDOW_PROVIDERS = [
    { provide: WindowRef, useClass: BrowserWindowRef },
    { provide: WINDOW, useFactory: windowFactory, deps: [WindowRef, PLATFORM_ID] }
];

let NgCoreModule = class NgCoreModule {
};
NgCoreModule.ɵfac = function NgCoreModule_Factory(t) { return new (t || NgCoreModule)(); };
NgCoreModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgCoreModule });
NgCoreModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[]] });

const CDN_CONFIG = new InjectionToken('CDN_CONFIG');

let CdnPipe = class CdnPipe {
    constructor(cdnConfig) {
        this.cdnConfig = cdnConfig;
    }
    transform(value, baseCdn, args) {
        value = value || "";
        let cdnUrl = this.cdnConfig.project;
        if (baseCdn) {
            cdnUrl = this.cdnConfig.base;
        }
        // If both CDN url and path have '/', remove one and append.
        if (this.endsWith(cdnUrl, '/') && this.beginsWith(value, '/')) {
            return cdnUrl + value.substring(1);
        }
        // If both CDN and path are missing '/', add one.
        if (!this.endsWith(cdnUrl, '/') && !this.beginsWith(value, '/')) {
            return cdnUrl + '/' + value;
        }
        // If CDN Url is already on the path, just return value
        if (value && value.indexOf(cdnUrl) >= 0) {
            return value;
        }
        return cdnUrl + value;
    }
    endsWith(value, search) {
        return value.substring(value.length - search.length, value.length) === search;
    }
    beginsWith(value, search) {
        return value.substring(0, search.length) === search;
    }
};
CdnPipe.ɵfac = function CdnPipe_Factory(t) { return new (t || CdnPipe)(ɵngcc0.ɵɵdirectiveInject(CDN_CONFIG)); };
CdnPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "cdn", type: CdnPipe, pure: true });
CdnPipe.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: CdnPipe, factory: function (t) { return CdnPipe.ɵfac(t); } });
CdnPipe.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [CDN_CONFIG,] }] }
];
CdnPipe = __decorate([ __param(0, Inject(CDN_CONFIG))
], CdnPipe);

let CdnPipeModule = class CdnPipeModule {
};
CdnPipeModule.ɵfac = function CdnPipeModule_Factory(t) { return new (t || CdnPipeModule)(); };
CdnPipeModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CdnPipeModule });
CdnPipeModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [
        CdnPipe
    ], imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BrowserWindowRef, [{
        type: Injectable
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgCoreModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [],
                exports: []
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CdnPipe, [{
        type: Injectable
    }, {
        type: Pipe,
        args: [{
                name: 'cdn'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [CDN_CONFIG]
            }] }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CdnPipeModule, { declarations: function () { return [CdnPipe]; }, imports: function () { return [CommonModule]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CdnPipeModule, [{
        type: NgModule,
        args: [{
                declarations: [CdnPipe],
                imports: [
                    CommonModule
                ],
                providers: [
                    CdnPipe
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of ng-core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BrowserWindowRef, CDN_CONFIG, CdnPipe, CdnPipeModule, NgCoreModule, WINDOW, WINDOW_PROVIDERS, WindowRef, windowFactory };

//# sourceMappingURL=atlas-ng-core.js.map